import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TrainingPage } from './training';

import { ComponentsModule } from './../../components/components.module';

@NgModule({
  declarations: [
    TrainingPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(TrainingPage),
  ],
})
export class TrainingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/training/training.module.ts